export default __webpack_public_path__ + "static/media/iphone-14-pro-max.18e5509e.webp";